import { render, staticRenderFns } from "./SellInLateral.vue?vue&type=template&id=0c31f49e&lang=html&"
import script from "./SellInLateral.vue?vue&type=script&lang=js&"
export * from "./SellInLateral.vue?vue&type=script&lang=js&"
import style0 from "./SellInLateral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/sell-in/SellInLateral.vue
// module id = 1471
// module chunks = 28